<template>
<div class="container">
    <core-header :user="user"></core-header>
    <core-nav-main :user="user"></core-nav-main>
    <md-layout class="account" md-row md-align="center" md-vertical-align="center">
        <md-layout md-flex="100" class="layout-separator"></md-layout>

        <md-layout md-flex="100" md-align="center" class="account-subscription-status">
            <div v-if="user.active_pay">
                <span>Subscription Status: <strong>Collaborator</strong></span>
            </div>
            <div v-else>
                <span>Subscription Status: <strong>Observer</strong></span>
                <md-button class="md-raised" @click="upgradeSubscription">Upgrade</md-button>
            </div>
        </md-layout>

        <md-layout md-flex="100" class="layout-separator"></md-layout>

        <md-layout md-flex="60">
            <md-avatar class="md-xxlarge">
                <img :src="user.profile_picture" alt="People" v-if="user.profile_picture" @click="openDialog" />
                <img :src="require('../assets/img/silhouette.jpg')" v-else alt="People" @click="openDialog" />
                <md-tooltip md-direction="right" md-delay="500" v-if="user.signInMethod==='email'">Click to upload a new photo</md-tooltip>
                <md-tooltip md-direction="right" md-delay="500" v-else>Update your user profile photo in your Google account settings.</md-tooltip>
            </md-avatar>
            <profile-photo ref="imageUpload"></profile-photo>
        </md-layout>

        <md-layout md-flex="100" class="layout-separator"></md-layout>

        <md-layout md-flex="30" md-offset="35" md-align="center" v-if="editingName">
            <form novalidate @submit.stop.prevent="saveName">
                <md-input-container>
                    <label>Name</label>
                    <md-input v-model="new_username"></md-input>
                </md-input-container>
                <md-button class="md-raised" @click="cancelEditingName">Cancel</md-button>
                <md-button class="md-raised md-primary" @click="saveName">Save</md-button>
            </form>
        </md-layout>

        <md-layout md-flex="100" md-align="center" v-else>
            <div class="md-headline ql-user-name" @click="editName">{{user.username}}</div>
            <md-tooltip v-if="user.signInMethod==='email'">click to change</md-tooltip>
            <md-tooltip v-else>Update your user name in your Google account settings.</md-tooltip>
        </md-layout>

        <md-layout md-flex="100" class="layout-separator"></md-layout>

        <md-layout md-flex="30" md-offset="35" md-align="center">
            <change-password v-if="user.signInMethod==='email'"></change-password>
        </md-layout>
        
        <md-layout md-flex="100" class="layout-separator"></md-layout>
    </md-layout>
    <core-footer></core-footer>
</div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

import CoreNavMain from '@/components/core/nav/main';
import CoreHeader from '@/components/core/header';
import CoreFooter from '@/components/core/footer';
import ProfilePhoto from '@/components/account/profile-photo';
import ChangePassword from '@/components/account/change-password';

const AccountView = {
    name: 'account',
    data: function() {
        return {
            editingName: false
        };
    },
    computed: {
        ...mapGetters([
            'user'
        ]),
        isNameComplete() {
            return this.new_username !== '';
        }
    },
    methods: {
        openDialog() {
            if (this.user.signInMethod === 'email') {
                this.$refs.imageUpload.open();
            }
        },
        editName() {
            if (this.user.signInMethod === 'email') {
                this.editingName = true;
                this.new_username = this.user.username;
            }
        },
        saveName() {
            if (this.new_username !== '') {
                this.$store.dispatch('updateUser', {
                    uid: this.user.uid, 
                    update: {
                        username: this.new_username
                    }
                });
            }
            this.editingName = false;
        },
        cancelEditingName() {
            this.editingName = false;
        },
        upgradeSubscription() {
            window.open('https://www.thecuelist.com/subscribe/');
        }
    },
    components: {
        'core-nav-main': CoreNavMain,
        'core-header': CoreHeader,
        'core-footer': CoreFooter,
        'profile-photo': ProfilePhoto,
        'change-password': ChangePassword
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            vm.$store.dispatch('setActiveUser', {
                ref: firebase.database().ref(`users/${firebase.auth().currentUser.uid}`),
                options: { }
            });
        });
    }
};
export default AccountView;
</script>

<style lang="scss">
.account {
    min-height: calc(100% - 64px);
    .md-avatar,
    .ql-user-name {
        cursor: pointer;
    }
}
.md-avatar.md-xxlarge {
    width: 256px;
    min-width: 256px;
    height: 256px;
    min-height: 256px;
    border-radius: 256px;
}
.account-subscription-status {
    text-align: center;
    span {
        font-size: 17px;
        display: block;
    }
    .md-button {
        margin: 15px auto;
    }
}
</style>


// WEBPACK FOOTER //
// account.vue?c164e13a